<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Global word-selection → Clear Word tooltip -->
<app-word-lookup-popover *ngIf="feature_clearword"></app-word-lookup-popover>

<!-- Navigation -->
<fuse-vertical-navigation
  *ngIf="showVerticalNavigation"
  class="dark bg-gray-900 print:hidden"
  data-tour="nav-sidebar"
  [appearance]="'compact'"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="hasAdminRole ? navigation.admin : navigation.compact"
  [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex items-center justify-center h-20 mt-3 mb-4">
      <img class="w-20" src="assets/images/logo/studema-logo-white.png" alt="Studema Online Training" />
    </div>
    
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="page-container flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div
    class="header relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow border-b print:hidden"
    [ngClass]="feature_header_white_bg ? 'bg-white' : 'bg-gray-900 dark:shadow-none dark:border-b dark'">
    <!-- Navigation toggle button -->
    <ng-container *ngIf="showVerticalNavigation">
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')" class="nav-toggle-button">
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
      </button>
    </ng-container>

    <ng-container *ngIf="!showVerticalNavigation">
      <div class="brandLogo">
        <button (click)="goHome()">
          <img style="max-height: 40px !important"
               [src]="navLogoUrl || ('assets/_clients/' + _client + '/' + (feature_header_white_bg ? _logo : _logo_white))"
               [alt]="_branding" />
        </button>

        <!--
        <ng-container *ngIf="_client == 'knusperstube'">
          <button (click)="goHome()">
            <img
              style="max-height: 40px !important"
              src="assets/_clients/knusperstube/client-logo-white.png"
              alt="Knusperstube Online Schulungen" />
          </button>
        </ng-container>
        <ng-container *ngIf="_client == 'performia'">
          <button (click)="goHome()">
            <img style="max-height: 40px !important" src="assets/_clients/performia/performia-logo.png" />
          </button>
        </ng-container>
        <ng-container *ngIf="_client == 'studema'">
          <button (click)="goHome()">
            <img style="max-height: 40px !important" src="assets/_clients/studema/studema-logo-white.png" alt="Studema Online Training" />
          </button>
        </ng-container>
        <ng-container *ngIf="_client == 'ollie'">
          <button (click)="goHome()">
            <img style="max-height: 40px !important" src="assets/_clients/ollie/logo-ollie.svg" alt="Ollie" />
          </button>
        </ng-container>
        -->
      </div>
    </ng-container>

    <!-- Components -->
    <div class="flex flex-nowrap items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <!--

                EXTRA NAV MENU

             -->

      <div class="flex items-center sm:ml-2 space-x-3">
        <!--
        <button class="bg-secondary" mat-flat-button [color]="'secondary'" (click)="toggleTwinning()">
          <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:envelope'"></mat-icon>
          <span class="ml-2">Show Twinning</span>
        </button>
        -->

        <!-- Class Admin link hidden - no longer needed
        <div *ngIf="_feature_classroom">
          <a (click)="gotoClassroomAdmin()" class="text-sm font-medium text-primary hover:underline"> Class Admin </a>
        </div>
        -->

        <!-- Home button -->
        <a routerLink="/home"
           mat-icon-button
           [matTooltip]="'Home'"
           class="text-current">
          <mat-icon [svgIcon]="'heroicons_outline:home'"></mat-icon>
        </a>

        <!-- Game Zone button — leftmost in the header actions -->
        <div *ngIf="feature_game">
          <ng-container *ngIf="isMobile; else gameZoneDesktop">
            <button mat-flat-button
                    style="background:#f97316; color:#fff;"
                    (click)="goToGameHub()"
                    [matTooltip]="'Game Zone'">
              <span style="font-size:18px; line-height:1;">🎮</span>
            </button>
          </ng-container>
          <ng-template #gameZoneDesktop>
            <button mat-flat-button
                    style="background:#f97316; color:#fff;"
                    (click)="goToGameHub()">
              <span style="font-size:16px; line-height:1; margin-right:6px;">🎮</span>
              <span class="ml-1">Game Zone</span>
            </button>
          </ng-template>
        </div>

        <!-- Independent feature flags for top nav buttons -->
        <div *ngIf="feature_clearword || feature_chat_supervisor || feature_ihaveawin">
          <ng-container *ngIf="isMobile; else elseTopNavBar">
            <button *ngIf="feature_clearword" class="bg-accent" mat-flat-button [color]="'accent'" (click)="clearWords()" data-tour="clearword-btn">
              <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:sun'"></mat-icon>
            </button>

            <button *ngIf="feature_ihaveawin && _role === UserRole.Student" mat-flat-button color="warn" (click)="openWinDialog()" data-tour="win-btn">
              <mat-icon class="icon-size-5">emoji_events</mat-icon>
            </button>

            <button *ngIf="feature_chat_supervisor" mat-flat-button [color]="'primary'" (click)="callSupervisor()" class="relative" data-tour="chat-btn">
              <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:chat-bubble-bottom-center-text'"></mat-icon>
              <!-- Green badge for unread chat messages -->
              <div *ngIf="totalUnreadMessages > 0" class="absolute -top-4 -right-4 flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-semibold text-white rounded-full" style="background-color: #9bbb58;">
                {{ totalUnreadMessages }}
              </div>
            </button>
          </ng-container>

          <ng-template #elseTopNavBar>
            <button *ngIf="feature_clearword" class="bg-accent" mat-flat-button [color]="'accent'" (click)="clearWords()" data-tour="clearword-btn">
              <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:sun'"></mat-icon>
              <span class="ml-2">{{ 'clearword.title' | translate }}</span>
            </button>

            <button *ngIf="feature_ihaveawin && _role === UserRole.Student" mat-flat-button color="warn" (click)="openWinDialog()" class="ml-1" data-tour="win-btn">
              <mat-icon class="icon-size-5">emoji_events</mat-icon>
              <span class="ml-2">{{ 'win.navButton' | translate }}</span>
            </button>

            <button *ngIf="feature_chat_supervisor" mat-flat-button [color]="'primary'" (click)="callSupervisor()" class="relative" data-tour="chat-btn">
              <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:chat-bubble-bottom-center-text'"></mat-icon>
              <span class="ml-2">{{ 'nav.chat' | translate }}</span>
              <!-- Green badge for unread chat messages -->
              <div *ngIf="totalUnreadMessages > 0" class="absolute -top-4 -right-4 flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-semibold text-white rounded-full" style="background-color: #9bbb58;">
                {{ totalUnreadMessages }}
              </div>
            </button>
          </ng-template>
        </div>
      </div>

      <!-- Pending steps review icon (for supervisors/admins) -->
      <ng-container *ngIf="_role !== UserRole.Student">
        <button mat-icon-button (click)="navigateToSupervisorPage()" matTooltip="Steps awaiting review">
          <ng-container *ngIf="totalPendingStepsCount > 0">
            <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
              <span
                class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full text-white text-xs font-medium"
                style="background-color: #e77e2e;">
                {{ totalPendingStepsCount > 99 ? '99+' : totalPendingStepsCount }}
              </span>
            </span>
          </ng-container>
          <mat-icon [svgIcon]="'heroicons_outline:clipboard-document-check'"></mat-icon>
        </button>
      </ng-container>

      <!-- Notifications bell icon (for supervisors/admins) -->
      <ng-container *ngIf="_role !== UserRole.Student">
        <notifications></notifications>
      </ng-container>

      <!-- chat button
      <button class="" mat-icon-button (click)="quickChat.toggle()">
        <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
      </button>
    -->

      <!--
      <button class="" mat-icon-button (click)="chatDrawer.toggle()">
        <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
      </button>
-->

      <!-- Goto Course Admin button hidden - no longer needed
      <div *ngIf="hasSUPermission">
        <button (click)="gotoLiveSystem()">{{ 'nav.gotoCourseAdmin' | translate }} &gt;</button>
      </div>
      -->

      <!-- Help / FAQ button — controllable per company via feature_help; hidden for students -->
      <button *ngIf="feature_help && hasSUPermission" mat-icon-button [matTooltip]="'nav.helpFaq' | translate" (click)="openHelpDialog()" class="mr-1" data-tour="support-btn">
        <mat-icon [svgIcon]="'heroicons_outline:question-mark-circle'"></mat-icon>
      </button>

      <!-- Company Selector - in top nav before user profile -->
      <app-company-selector class="mr-2" (companyChanged)="onCompanyChanged($event)"></app-company-selector>

      <user data-tour="user-menu" (openHelpRequested)="openHelpDialog()"></user>

      <!-- Language selector moved to Settings page
      <languages></languages>
      -->
    </div>
  </div>

  <!-- Content -->
  <div class="content flex flex-col flex-auto bg-white dark:bg-gray-800">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer (hidden for cleaner UI) -->
  <!-- <div
    class="footer flex text-sm flex-0 items-center justify-start w-full h-14 px-4 md:px-6 border-t bg-card dark:bg-transparent print:hidden">
    <span class="mx-auto text-xs text-gray-500" *ngIf="hasAdminRole">You are logged on as {{ adminRoleName }}</span>
  </div> -->
</div>

<!-- Quick chat
<quick-chat fixed #quickChat="quickChat"></quick-chat>
 -->

<fuse-drawer
  class="w-screen min-w-screen sm:w-100 sm:min-w-100 z-999"
  [fixed]="true"
  [mode]="'side'"
  [name]="'chatDrawer'"
  [position]="'right'"
  #chatDrawer>
  <div class="fixed top-0 bottom-0 w-full sm:w-100 bg-card">
    <div class="flex flex-col w-full h-full transition-transform duration-400 ease-drawer" [ngSwitch]="drawerMode">
      <!-- 🔠 Dictionary Content -->
      <ng-container *ngSwitchCase="'dictionary'">
        <!-- Header -->
        <div class="flex items-center justify-between px-4 py-3 border-b bg-gray-100 dark:bg-transparent">
          <h2 class="text-lg font-medium">{{ 'clearword.title' | translate }}</h2>
          <button mat-icon-button (click)="closeDrawer()">
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
          </button>
        </div>

        <!-- Content -->
        <div class="flex-1 overflow-auto p-4">
          <app-dictionary-lookup></app-dictionary-lookup>
        </div>
      </ng-container>

      <!-- 💬 Chat Content -->
      <ng-container *ngSwitchDefault>
        <!-- Header -->
        <div class="quick-chat-header flex flex-0 items-center justify-start cursor-pointer">
          <div class="flex p-3 flex-auto items-center gap-3" style="background: #eef2ff">
            <!-- Student view: show supervisor avatar + name if available, otherwise generic icon -->
            <ng-container *ngIf="_role === UserRole.Student">
              <ng-container *ngIf="supervisorInfo; else genericChatIcon">
                <!-- Supervisor avatar -->
                <div class="flex-shrink-0 w-9 h-9 rounded-full overflow-hidden border border-blue-200 shadow-sm">
                  <img *ngIf="supervisorInfo.avatar"
                       [src]="supervisorInfo.avatar"
                       [alt]="supervisorInfo.name"
                       class="w-full h-full object-cover"
                       (error)="supervisorInfo = { name: supervisorInfo.name, avatar: null }" />
                  <div *ngIf="!supervisorInfo.avatar"
                       class="w-full h-full flex items-center justify-center bg-blue-100 text-blue-600 font-bold text-sm uppercase">
                    {{ supervisorInfo.name.charAt(0) }}
                  </div>
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="text-sm font-semibold text-gray-800 leading-tight truncate">{{ supervisorInfo.name }}</span>
                  <span class="text-xs text-gray-500 leading-tight">{{ 'chat.askTeacher' | translate }}</span>
                </div>
              </ng-container>
              <ng-template #genericChatIcon>
                <div class="flex flex-0 items-center justify-center w-9 h-9">
                  <mat-icon class="icon-size-6 text-blue-500" [svgIcon]="'heroicons_outline:chat-bubble-bottom-center-text'"></mat-icon>
                </div>
                <div class="text-base font-medium text-gray-700">{{ 'chat.askTeacher' | translate }}</div>
              </ng-template>
            </ng-container>
            <!-- Supervisor / admin view: show the logged-in user's own avatar + name in the header -->
            <ng-container *ngIf="_role !== UserRole.Student">
              <!-- Logged-in user avatar -->
              <div class="flex-shrink-0 w-9 h-9 rounded-full overflow-hidden border border-gray-200 shadow-sm">
                <img *ngIf="currentUserAvatarUrl"
                     [src]="currentUserAvatarUrl"
                     [alt]="currentUserDisplayName"
                     class="w-full h-full object-cover" />
                <div *ngIf="!currentUserAvatarUrl"
                     class="w-full h-full flex items-center justify-center bg-blue-100 text-blue-700 font-bold text-sm uppercase">
                  {{ (currentUserDisplayName || 'U').charAt(0) }}
                </div>
              </div>
              <!-- Name + subtitle -->
              <div class="flex flex-col min-w-0">
                <span class="text-sm font-semibold text-gray-800 leading-tight truncate">{{ currentUserDisplayName }}</span>
                <span class="text-xs text-gray-500 leading-tight">{{ 'Chat with Students' | translate }}</span>
              </div>
            </ng-container>
            <!-- Mute button (only for students with AI chat enabled) -->
            <ng-container *ngIf="_role === UserRole.Student && feature_ai">
              <button 
                class="ml-auto mr-2" 
                mat-icon-button 
                [matTooltip]="isAiMuted ? ('Unmute AI' | translate) : ('Mute AI' | translate)"
                [disabled]="isMuteButtonDisabled"
                (click)="toggleAiMute()">
                <mat-icon [svgIcon]="isAiMuted ? 'heroicons_outline:speaker-x-mark' : 'heroicons_outline:speaker-wave'"></mat-icon>
              </button>
            </ng-container>
            <button class="ml-auto mr-4" mat-icon-button (click)="closeDrawer()">
              <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
          </div>
        </div>

        <!-- Content -->
        <div class="flex-1 overflow-hidden flex flex-col">
          <!-- For Students: Direct chat interface -->
          <ng-container *ngIf="_role === UserRole.Student">
            
            <!-- Inline video at top of chat content (for students) -->
            <ng-container *ngIf="drawerMode === 'chat' && _feature_classroom">
              <div class="flex-shrink-0 p-2 border-b bg-gray-50 dark:bg-gray-800">
                <!-- Video wrapper with badge and controls (matching selfie dialog structure) -->
                <div class="video-wrapper w-full">
                  <!-- Top-left "You" badge -->
                  <span class="absolute top-2 left-2 text-white bg-black bg-opacity-50 px-2 py-1 rounded">
                    {{ 'You' | translate }}
                  </span>
                  <!-- Video element (black background when no track) -->
                  <video #inlineVideoElement autoplay muted playsinline class="video-box w-full h-[150px] rounded bg-black" [style.display]="hasVideoTrack ? 'block' : 'none'"></video>
                  <!-- Black background when video track is not available -->
                  <div *ngIf="!hasVideoTrack" class="w-full h-[150px] bg-black rounded"></div>
                  <!-- Bottom-center control buttons -->
                  <div class="controls-bottom-center">
                    <button mat-icon-button (click)="toggleInlineAudio()" class="control-btn">
                      <mat-icon>{{ isInlineAudioMuted ? 'mic_off' : 'mic' }}</mat-icon>
                    </button>
                    <button mat-icon-button (click)="toggleInlineVideo()" class="control-btn">
                      <mat-icon>{{ isInlineVideoHidden ? 'videocam_off' : 'videocam' }}</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
            
            <!-- AI Chat (only render/connect inside /academy/*) -->
            <ng-container *ngIf="feature_ai && isAcademyContext && aiChatConfig.showWidget">
              <div class="flex flex-col flex-1 min-h-0 w-full" style="min-height: 0;">
                <ai-chat-component
                  #aiChatTeacher
                  class="block w-full flex-1 min-h-0"
                  style="display: block; width: 100%; height: 100%; min-height: 0; flex: 1 1 auto;"
                  [attr.ai-content]="aiChatContentJson">
                </ai-chat-component>
              </div>


            </ng-container>
            
            <!-- Normal Teacher Chat (when feature_ai is disabled) -->
            <ng-container *ngIf="!feature_ai">
              <!-- Simple chat interface for students -->
              <div class="flex flex-col flex-1 min-h-0 relative">
                <!-- Messages area - uses flex-1 to take remaining space -->
                <div #messagesContainer 
                     class="flex-1 p-4 overflow-y-auto min-h-0 scroll-smooth"
                     (scroll)="onMessagesScroll()">
                
                <!-- Scroll to bottom button - only shows when scrolled up -->
                <button 
                  *ngIf="showScrollToBottom && chatMessages.length > 3"
                  (click)="scrollToBottomPublic()"
                  class="absolute bottom-24 right-6 z-10 w-9 h-9 rounded-full bg-gray-300/30 text-gray-400 hover:bg-gray-300/50 hover:text-gray-500 transition-all flex items-center justify-center"
                  [matTooltip]="'chat.scrollToBottom' | translate">
                  <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:chevron-double-down'"></mat-icon>
                </button>
                  <ng-container *ngIf="groupedMessages.length; else chatEmptyStudent">
                    <!-- Messages grouped by step -->
                    <div class="space-y-6">
                      <div *ngFor="let group of groupedMessages" 
                           [id]="'step-group-' + group.stepId"
                           class="step-message-group">
                        <!-- Step header - clickable to navigate to step -->
                        <div class="flex flex-col gap-1 mb-3 sticky top-0 z-10 bg-gray-50 dark:bg-gray-900 py-2 -mx-4 px-4 border-b border-gray-200 dark:border-gray-700 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                             [ngClass]="{ 'bg-blue-50 dark:bg-blue-900/30 border-blue-200 dark:border-blue-700 hover:bg-blue-100 dark:hover:bg-blue-900/50': currentStepId === group.stepId }"
                             (click)="navigateToStep(group.stepId)"
                             [matTooltip]="group.stepId ? ('chat.clickToGoToStep' | translate) : ''">
                          <!-- Course title row -->
                          <div *ngIf="group.courseTitle" class="flex items-center gap-1">
                            <mat-icon class="icon-size-3 text-gray-400" [svgIcon]="'heroicons_outline:academic-cap'"></mat-icon>
                            <span class="text-xs font-medium text-gray-500 dark:text-gray-400 truncate">
                              {{ group.courseTitle }}
                            </span>
                          </div>
                          <!-- Step title row -->
                          <div class="flex items-center gap-2">
                            <mat-icon class="icon-size-4 text-gray-400 flex-shrink-0" [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
                            <span class="text-xs font-semibold text-gray-700 dark:text-gray-300 flex-1 line-clamp-2">
                              {{ group.stepTitle }}
                            </span>
                            <span class="text-xs text-gray-400 dark:text-gray-500 flex-shrink-0">
                              {{ group.messages.length }} {{ (group.messages.length === 1 ? 'chat.msg' : 'chat.msgs') | translate }}
                            </span>
                            <!-- Arrow icon to indicate clickable -->
                            <mat-icon *ngIf="group.stepId" class="icon-size-4 text-gray-400 flex-shrink-0" [svgIcon]="'heroicons_outline:arrow-right'"></mat-icon>
                          </div>
                        </div>
                        
                        <!-- Messages in this step -->
                        <div class="space-y-4">
                          <div *ngFor="let msg of group.messages" 
                               class="chat-message flex items-start gap-2" 
                               [ngClass]="{ 'flex-row-reverse': msg.sender === 'me' }">
                            <!-- Avatar with fallback -->
                            <div class="w-10 h-10 flex-shrink-0">
                              <img *ngIf="msg.senderAvatar && !msg.avatarError"
                                   [src]="msg.senderAvatar" 
                                   [alt]="msg.senderName || 'Avatar'"
                                   (error)="msg.avatarError = true"
                                   class="w-10 h-10 rounded-full object-cover border border-gray-200 dark:border-gray-700" />
                              <!-- Fallback avatar when no image or error -->
                              <div *ngIf="!msg.senderAvatar || msg.avatarError"
                                   class="w-10 h-10 rounded-full flex items-center justify-center text-lg font-semibold uppercase border border-gray-200 dark:border-gray-700"
                                   [ngClass]="msg.sender === 'me' ? 'bg-blue-100 text-blue-600 dark:bg-blue-900 dark:text-blue-300' : 'bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-300'">
                                {{ (msg.senderName || 'U').charAt(0) }}
                              </div>
                            </div>
                            <!-- Message content -->
                            <div class="flex flex-col flex-1" [ngClass]="{ 'items-end': msg.sender === 'me', 'items-start': msg.sender !== 'me' }">
                              <!-- Sender name and date/time -->
                              <div class="flex items-center gap-2 mb-1" [ngClass]="{ 'flex-row-reverse': msg.sender === 'me' }">
                                <span class="text-xs font-semibold" [ngClass]="msg.sender === 'me' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-700 dark:text-gray-300'">
                                  {{ msg.senderName ? msg.senderName : ((msg.sender === 'me' ? 'chat.you' : 'chat.supervisor') | translate) }}
                                </span>
                                <span class="text-xs text-gray-500 dark:text-gray-400">
                                  {{ msg.date }} {{ msg.time }}
                                </span>
                              </div>
                              <!-- Message bubble -->
                              <div class="flex items-end gap-1" [ngClass]="{ 'flex-row-reverse': msg.sender === 'me' }">
                                <!-- Message text -->
                                <ng-container *ngIf="msg.text">
                                  <div class="block w-full px-4 py-2 rounded-lg relative" 
                                       [ngClass]="msg.sender === 'me' ? 'bg-blue-600 text-white rounded-br-sm' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-bl-sm'">
                                    <div class="text-sm whitespace-pre-wrap break-words chat-message-content" [innerHTML]="msg.text"></div>
                                    <!-- Status indicator (only for sent messages) -->
                                    <div *ngIf="msg.sender === 'me' && msg.status" class="flex items-center justify-end mt-1 gap-1">
                                      <span class="text-[10px] opacity-75">
                                        <ng-container *ngIf="msg.status === 'sent'">✓</ng-container>
                                        <ng-container *ngIf="msg.status === 'delivered'">✓✓</ng-container>
                                        <ng-container *ngIf="msg.status === 'read'">
                                          <span class="text-blue-300">✓✓</span>
                                          <span *ngIf="msg.ackAt" class="text-[9px] text-blue-200 ml-0.5">{{ msg.ackAt | date:'MMM d, HH:mm' }}</span>
                                          <span *ngIf="!msg.ackAt && msg.readAt" class="text-[9px] text-blue-200 ml-0.5">{{ msg.readAt | date:'MMM d, HH:mm' }}</span>
                                        </ng-container>
                                      </span>
                                    </div>
                                  </div>
                                </ng-container>
                                <!-- Message image (legacy data-URL preview) -->
                                <ng-container *ngIf="msg.imageUrl">
                                  <div class="relative">
                                    <img [src]="msg.imageUrl" class="inline-block max-w-[90%] rounded-lg border cursor-pointer"
                                         (click)="openLightbox([{url: msg.imageUrl, name: 'image'}], 0)" />
                                    <!-- Status indicator for images -->
                                    <div *ngIf="msg.sender === 'me' && msg.status" class="absolute bottom-1 right-1 bg-black bg-opacity-50 rounded px-1 flex items-center gap-0.5">
                                      <span class="text-[10px] text-white">
                                        <ng-container *ngIf="msg.status === 'sent'">✓</ng-container>
                                        <ng-container *ngIf="msg.status === 'delivered'">✓✓</ng-container>
                                        <ng-container *ngIf="msg.status === 'read'">
                                          <span class="text-blue-300">✓✓</span>
                                        </ng-container>
                                      </span>
                                      <span *ngIf="msg.status === 'read' && msg.ackAt" class="text-[9px] text-blue-200">{{ msg.ackAt | date:'MMM d, HH:mm' }}</span>
                                      <span *ngIf="msg.status === 'read' && !msg.ackAt && msg.readAt" class="text-[9px] text-blue-200">{{ msg.readAt | date:'MMM d, HH:mm' }}</span>
                                    </div>
                                  </div>
                                </ng-container>
                                <!-- Attached files from server -->
                                <ng-container *ngIf="msg.attachedFiles && msg.attachedFiles.length > 0">
                                  <div class="mt-1 flex flex-wrap gap-2">
                                    <ng-container *ngFor="let f of msg.attachedFiles; let fi = index">
                                      <!-- Image thumbnail -->
                                      <div *ngIf="f.is_image && !isImageFailed(f.id)"
                                           class="relative cursor-pointer rounded overflow-hidden border border-white/20"
                                           (click)="openLightbox(collectImageAttachments(chatMessages), fi)">
                                        <img [src]="attachmentServeUrl(f)" class="max-w-[220px] max-h-[180px] object-cover rounded" [alt]="f.original_name"
                                             (error)="onImageError(f.id)" />
                                        <div class="absolute inset-0 hover:bg-black/20 transition-colors flex items-center justify-center">
                                          <mat-icon class="text-white opacity-0 hover:opacity-100 icon-size-6" [svgIcon]="'heroicons_outline:magnifying-glass-plus'"></mat-icon>
                                        </div>
                                      </div>
                                      <!-- File card -->
                                      <a *ngIf="!f.is_image || isImageFailed(f.id)"
                                         [href]="attachmentServeUrl(f)"
                                         target="_blank"
                                         style="text-decoration:none;"
                                         class="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors no-underline text-inherit">
                                        <!-- PDF -->
                                        <svg *ngIf="f.mime_type === 'application/pdf'" class="flex-shrink-0 w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="currentColor">
                                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM8.5 15.5v-5h2c1.1 0 2 .9 2 2s-.9 2-2 2H9.5v1.5h-1zm1-2.5h1c.55 0 1-.45 1-1s-.45-1-1-1h-1v2zm4.5 2.5v-5h1.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5H14zm1-1h.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H15v3z"/>
                                        </svg>
                                        <!-- Word -->
                                        <svg *ngIf="f.mime_type === 'application/msword' || f.mime_type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" class="flex-shrink-0 w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="currentColor">
                                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM7 14l1.5-5h1l1 3.5 1-3.5h1L15 14h-1l-1.1-3.7L11.8 14h-1L9.8 10.3 8.7 14H7z"/>
                                        </svg>
                                        <!-- Excel -->
                                        <svg *ngIf="f.mime_type === 'application/vnd.ms-excel' || f.mime_type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" class="flex-shrink-0 w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="currentColor">
                                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM7 14l2-3-2-3h1.5l1.25 2 1.25-2H12.5l-2 3 2 3H11l-1.25-2-1.25 2H7z"/>
                                        </svg>
                                        <!-- PowerPoint -->
                                        <svg *ngIf="f.mime_type === 'application/vnd.ms-powerpoint' || f.mime_type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'" class="flex-shrink-0 w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="currentColor">
                                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM8 10h3c1.1 0 2 .9 2 2s-.9 2-2 2H9v2H8v-6zm1 3h2c.55 0 1-.45 1-1s-.45-1-1-1H9v2z"/>
                                        </svg>
                                        <!-- Generic (ZIP, TXT, etc.) -->
                                        <svg *ngIf="f.mime_type !== 'application/pdf' && f.mime_type !== 'application/msword' && f.mime_type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && f.mime_type !== 'application/vnd.ms-excel' && f.mime_type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && f.mime_type !== 'application/vnd.ms-powerpoint' && f.mime_type !== 'application/vnd.openxmlformats-officedocument.presentationml.presentation'"
                                             class="flex-shrink-0 w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                                        </svg>
                                        <div class="min-w-0">
                                          <div class="text-xs font-medium truncate max-w-[160px]">{{ f.original_name }}</div>
                                          <div class="text-[10px] opacity-70">{{ formatFileSize(f.file_size) }}</div>
                                        </div>
                                        <!-- Download arrow -->
                                        <svg class="flex-shrink-0 w-3.5 h-3.5 text-white/80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                          <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                                        </svg>
                                      </a>
                                    </ng-container>
                                  </div>
                                </ng-container>
                              </div>
                              <!-- Action buttons row -->
                              <div class="flex items-center gap-2 mt-1 text-[10px] text-gray-500 dark:text-gray-400"
                                   *ngIf="(companyAckEnabled && msg.sender !== 'me' && !msg.ackAt && !msg.readAt) || (msg.stepId && msg.studentCourseId) || msg.ackAt">
                                <!-- OK / ACK button: students must acknowledge supervisor/twin messages -->
                                <button *ngIf="companyAckEnabled && msg.sender !== 'me' && !msg.ackAt && !msg.readAt"
                                        class="px-2 py-0.5 rounded font-semibold text-white transition-colors"
                                        style="background-color: #9bbb58;"
                                        onmouseover="this.style.backgroundColor='#82a347'"
                                        onmouseout="this.style.backgroundColor='#9bbb58'"
                                        (click)="acknowledgeMessage(msg)">
                                  {{ 'chat.ok' | translate }}
                                </button>
                                <!-- GOTO step button -->
                                <button *ngIf="msg.stepId && msg.studentCourseId"
                                        class="flex items-center gap-0.5 px-2 py-0.5 rounded font-semibold text-white transition-colors"
                                        style="background-color: #4f7196;"
                                        onmouseover="this.style.backgroundColor='#3d5a77'"
                                        onmouseout="this.style.backgroundColor='#4f7196'"
                                        [matTooltip]="('chat.goTo' | translate) + (msg.stepTitle ? ': ' + msg.stepTitle : '')"
                                        (click)="navigateToChatStep(msg)">
                                  <mat-icon class="icon-size-3 text-white" [svgIcon]="'heroicons_mini:arrow-right'"></mat-icon>
                                  <span>{{ 'chat.go' | translate }}</span>
                                </button>
                                <!-- Already acknowledged -->
                                <span *ngIf="msg.ackAt">{{ 'chat.acked' | translate }} {{ msg.ackAt | date:'MMM dd, HH:mm' }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #chatEmptyStudent>
                    <div class="text-center text-gray-500">
                      <mat-icon class="icon-size-12 mb-4" [svgIcon]="'heroicons_outline:chat-bubble-bottom-center-text'"></mat-icon>
                      <p>{{ 'Start chatting with your teacher' | translate }}</p>
                    </div>
                  </ng-template>
                </div>
                
                <!-- Pending attachments row (student) -->
                <div *ngIf="pendingChatAttachments.length > 0"
                     class="flex flex-wrap gap-2 px-4 py-2 border-t bg-gray-50 dark:bg-transparent">
                  <div *ngFor="let att of pendingChatAttachments; let i = index"
                       class="flex items-center gap-2 px-2 py-1 rounded-lg bg-gray-200 dark:bg-gray-700 text-sm">
                    <!-- image preview -->
                    <img *ngIf="att.previewUrl" [src]="att.previewUrl" class="w-10 h-10 rounded object-cover flex-shrink-0" />
                    <!-- file icon -->
                    <mat-icon *ngIf="!att.previewUrl" class="icon-size-5 flex-shrink-0 text-gray-500" [svgIcon]="'heroicons_outline:document'"></mat-icon>
                    <div class="min-w-0 max-w-[120px]">
                      <div class="text-xs font-medium truncate">{{ att.file.name }}</div>
                      <div class="text-[10px] text-gray-500">{{ formatFileSize(att.file.size) }}</div>
                    </div>
                    <!-- uploading spinner -->
                    <div *ngIf="att.uploading" class="w-4 h-4 rounded-full border-2 border-blue-500 border-t-transparent animate-spin flex-shrink-0"></div>
                    <!-- error indicator -->
                    <mat-icon *ngIf="att.error" class="icon-size-4 text-red-500 flex-shrink-0" [svgIcon]="'heroicons_mini:exclamation-circle'"></mat-icon>
                    <!-- remove button -->
                    <button class="flex-shrink-0 text-gray-400 hover:text-gray-600 p-0.5" type="button" (click)="removePendingAttachment(i)">
                      <mat-icon class="icon-size-4" [svgIcon]="'heroicons_mini:x-mark'"></mat-icon>
                    </button>
                  </div>
                </div>
                <!-- Message input -->
                <div class="flex items-end p-4 border-t bg-gray-50 dark:bg-transparent">
                  <!-- Attachment button (left) -->
                  <div class="flex items-center h-11 my-px mr-4">
                    <input type="file" #attachmentInputStudent (change)="onAttachmentSelected($event)" class="hidden" />
                    <button mat-icon-button [attr.aria-label]="'chat.attachFile' | translate" type="button" (click)="attachmentInputStudent.click()">
                      <mat-icon [svgIcon]="'heroicons_outline:paper-clip'"></mat-icon>
                    </button>
                  </div>
                  <mat-form-field class="fuse-mat-dense fuse-mat-rounded fuse-mat-bold w-full" subscriptSizing="dynamic">
                    <textarea
                      matInput
                      cdkTextareaAutosize
                      [placeholder]="'chat.typeMessage' | translate"
                      [(ngModel)]="chatInput"
                      (keydown)="onChatKeydown($event)"
                      (paste)="onChatPaste($event)"></textarea>
                  </mat-form-field>
                  <div class="flex items-center h-11 my-px ml-4">
                    <button mat-icon-button [attr.aria-label]="'chat.sendMessage' | translate" type="button" (click)="sendChatMessage()">
                      <mat-icon [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
            
          </ng-container>

          <!-- For Admins/Supervisors: Students list -->
          <ng-container *ngIf="_role !== UserRole.Student">
            <div class="flex flex-col h-full">
              <!-- Student Chat Interface -->
              <ng-container *ngIf="isInStudentChat && selectedStudent; else studentsListView">
                <!-- Header with back button -->
                <div class="flex items-center justify-between p-4 border-b bg-gray-50 dark:bg-transparent">
                  <div class="flex items-center">
                    <button mat-icon-button (click)="backToStudentsList()" class="mr-2">
                      <mat-icon [svgIcon]="'heroicons_outline:arrow-long-left'"></mat-icon>
                    </button>
                    <div class="flex items-center">
                      <div class="relative flex flex-0 items-center justify-center w-8 h-8 mr-3">
                        <ng-container *ngIf="selectedStudentAvatarUrl">
                          <img class="w-full h-full rounded-full object-cover" [src]="selectedStudentAvatarUrl" alt="Student avatar" />
                        </ng-container>
                        <ng-container *ngIf="!selectedStudentAvatarUrl">
                          <div
                            class="flex items-center justify-center w-full h-full rounded-full text-sm uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                            {{ selectedStudent.name?.charAt(0) || '?' }}
                          </div>
                        </ng-container>
                      </div>
                      <div>
                        <div class="font-medium">{{ selectedStudent.name }}</div>
                        <div class="text-sm text-secondary">{{ selectedStudent.email }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Notification attention card (when student has pending notifications) -->
                <div *ngIf="getUnreadNotificationCount(selectedStudent?.t_ot_studentid) > 0"
                     class="mx-4 mt-4 mb-3 p-3 rounded-lg bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-700 flex items-center gap-3">
                  <mat-icon class="text-orange-500 flex-shrink-0" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
                  <div class="flex-1 min-w-0">
                    <div class="text-sm font-medium text-orange-800 dark:text-orange-200">
                      {{ getUnreadNotificationCount(selectedStudent?.t_ot_studentid) }} {{ 'chat.stepsNeedAttention' | translate }}
                    </div>
                    <div class="text-xs text-orange-600 dark:text-orange-400">{{ 'chat.workWaitingReview' | translate }}</div>
                  </div>
                  <button (click)="navigateToSupervisorReview(selectedStudent)"
                          class="text-xs px-2 py-1 rounded bg-orange-500 text-white hover:bg-orange-600 flex-shrink-0">
                    {{ 'chat.review' | translate }}
                  </button>
                </div>

                <!-- Chat messages area -->
                <div #adminMessagesContainer class="flex-1 p-4 overflow-y-auto" (scroll)="onAdminMessagesScroll()">
                  <ng-container *ngIf="chatMessages.length; else chatEmptyAdmin">
                    <!-- Earlier messages button / Begin indicator -->
                    <div *ngIf="chatHasMore" class="flex justify-center py-2">
                      <button (click)="loadMoreChatMessages()"
                              [disabled]="chatIsLoadingMore"
                              class="text-xs px-3 py-1 rounded-full border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400">
                        <span *ngIf="!chatIsLoadingMore">{{ 'chat.earlierMessages' | translate }}</span>
                        <span *ngIf="chatIsLoadingMore">{{ 'chat.loading' | translate }}</span>
                      </button>
                    </div>
                    <div *ngIf="!chatHasMore && chatMessages.length > 0" class="text-center text-xs text-gray-400 dark:text-gray-500 py-2">
                      {{ 'chat.begin' | translate }} · {{ chatMessages[0]?.date }} {{ chatMessages[0]?.time }}
                    </div>
                    <div class="space-y-3">
                      <div *ngFor="let msg of chatMessages" class="flex" [ngClass]="{ 'justify-end': msg.sender === 'me' }">
                        <div class="max-w-[92%] flex gap-2" [ngClass]="{ 'flex-row-reverse': msg.sender === 'me' }">
                          <!-- Avatar -->
                          <div class="w-8 h-8 flex-shrink-0">
                            <img *ngIf="msg.senderAvatar && !msg.avatarError"
                                 [src]="msg.senderAvatar"
                                 (error)="msg.avatarError = true"
                                 class="w-8 h-8 rounded-full object-cover border border-gray-200 dark:border-gray-700" />
                            <div *ngIf="!msg.senderAvatar || msg.avatarError"
                                 class="w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold uppercase border border-gray-200 dark:border-gray-700"
                                 [ngClass]="msg.sender === 'me' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200' : 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300'">
                              {{ (msg.senderName || 'U').charAt(0) }}
                            </div>
                          </div>
                          <!-- Message body -->
                          <div class="flex flex-col min-w-0" [ngClass]="{ 'items-end': msg.sender === 'me' }">
                            <div class="text-[11px] text-gray-500 dark:text-gray-400 mb-0.5" [ngClass]="{ 'text-right': msg.sender === 'me' }">
                              <span class="font-semibold">{{ msg.senderName || 'User' }}</span>
                              <span class="ml-1">({{ getSenderRoleLabel(msg) }})</span>
                              <span class="ml-2">{{ msg.date }} {{ msg.time }}</span>
                            </div>
                            <!-- Step context row — only shown when message is tied to a step -->
                            <div *ngIf="msg.stepId || msg.courseTitle || msg.isNotification"
                                 class="text-[10px] text-gray-500 dark:text-gray-400 mb-1 truncate max-w-[420px]"
                                 [matTooltip]="msg.stepTitle || ''">
                              {{ msg.courseTitle || '' }}<ng-container *ngIf="msg.courseTitle && msg.stepSort"> | </ng-container>{{ getShortStepLabel(msg) }}
                              <span *ngIf="msg.attentionState"
                                    class="ml-1 px-1.5 py-0.5 rounded-full text-[9px] font-semibold" [ngClass]="getAttentionStateClass(msg)">
                                {{ getAttentionStateLabel(msg) }}
                              </span>
                            </div>
                            <div class="w-fit max-w-[90%] px-3 py-2 rounded-lg" [ngClass]="msg.sender === 'me' ? 'bg-blue-600 text-white rounded-br-sm' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-bl-sm'">
                              <div *ngIf="msg.text" class="text-sm whitespace-pre-wrap break-words chat-message-content" [innerHTML]="msg.text"></div>
                              <!-- Legacy data-URL image -->
                              <img *ngIf="msg.imageUrl" [src]="msg.imageUrl" class="mt-1 max-w-[220px] rounded border cursor-pointer"
                                   (click)="openLightbox([{url: msg.imageUrl!, name: 'image'}], 0)" />
                              <!-- Attached files from server -->
                              <ng-container *ngIf="msg.attachedFiles && msg.attachedFiles.length > 0">
                                <div class="mt-1 flex flex-wrap gap-2">
                                  <ng-container *ngFor="let f of msg.attachedFiles; let fi = index">
                                    <!-- Image thumbnail -->
                                    <div *ngIf="f.is_image && !isImageFailed(f.id)"
                                         class="relative cursor-pointer rounded overflow-hidden border border-white/20"
                                         (click)="openLightbox(collectImageAttachments(chatMessages), fi)">
                                      <img [src]="attachmentServeUrl(f)" class="max-w-[220px] max-h-[180px] object-cover rounded" [alt]="f.original_name"
                                           (error)="onImageError(f.id)" />
                                    </div>
                                    <!-- File card -->
                                    <a *ngIf="!f.is_image || isImageFailed(f.id)"
                                       [href]="attachmentServeUrl(f)"
                                       target="_blank"
                                       style="text-decoration:none;"
                                       class="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors no-underline text-inherit">
                                      <!-- PDF -->
                                      <svg *ngIf="f.mime_type === 'application/pdf'" class="flex-shrink-0 w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM8.5 15.5v-5h2c1.1 0 2 .9 2 2s-.9 2-2 2H9.5v1.5h-1zm1-2.5h1c.55 0 1-.45 1-1s-.45-1-1-1h-1v2zm4.5 2.5v-5h1.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5H14zm1-1h.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H15v3z"/>
                                      </svg>
                                      <!-- Word -->
                                      <svg *ngIf="f.mime_type === 'application/msword' || f.mime_type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" class="flex-shrink-0 w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM7 14l1.5-5h1l1 3.5 1-3.5h1L15 14h-1l-1.1-3.7L11.8 14h-1L9.8 10.3 8.7 14H7z"/>
                                      </svg>
                                      <!-- Excel -->
                                      <svg *ngIf="f.mime_type === 'application/vnd.ms-excel' || f.mime_type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" class="flex-shrink-0 w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM7 14l2-3-2-3h1.5l1.25 2 1.25-2H12.5l-2 3 2 3H11l-1.25-2-1.25 2H7z"/>
                                      </svg>
                                      <!-- PowerPoint -->
                                      <svg *ngIf="f.mime_type === 'application/vnd.ms-powerpoint' || f.mime_type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'" class="flex-shrink-0 w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM8 10h3c1.1 0 2 .9 2 2s-.9 2-2 2H9v2H8v-6zm1 3h2c.55 0 1-.45 1-1s-.45-1-1-1H9v2z"/>
                                      </svg>
                                      <!-- Generic (ZIP, TXT, etc.) -->
                                      <svg *ngIf="f.mime_type !== 'application/pdf' && f.mime_type !== 'application/msword' && f.mime_type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && f.mime_type !== 'application/vnd.ms-excel' && f.mime_type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && f.mime_type !== 'application/vnd.ms-powerpoint' && f.mime_type !== 'application/vnd.openxmlformats-officedocument.presentationml.presentation'"
                                           class="flex-shrink-0 w-5 h-5 text-white/90" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                                      </svg>
                                      <div class="min-w-0">
                                        <div class="text-xs font-medium truncate max-w-[160px]">{{ f.original_name }}</div>
                                        <div class="text-[10px] opacity-70">{{ formatFileSize(f.file_size) }}</div>
                                      </div>
                                      <!-- Download arrow -->
                                      <svg class="flex-shrink-0 w-3.5 h-3.5 text-white/80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                                      </svg>
                                    </a>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </div>
                            <div class="flex items-center gap-2 mt-1 text-[10px] text-gray-500 dark:text-gray-400">
                              <!-- OK button: ONLY for students — supervisors/admins never ACK messages -->
                              <button *ngIf="_role === UserRole.Student && companyAckEnabled && msg.sender !== 'me' && !msg.ackAt && !msg.readAt"
                                      class="px-2 py-0.5 rounded font-semibold text-white transition-colors"
                                      style="background-color: #9bbb58;"
                                      onmouseover="this.style.backgroundColor='#82a347'"
                                      onmouseout="this.style.backgroundColor='#9bbb58'"
                                      (click)="acknowledgeMessage(msg)">
                                {{ 'chat.ok' | translate }}
                              </button>
                              <button *ngIf="msg.stepId && msg.studentCourseId"
                                      class="flex items-center gap-0.5 px-2 py-0.5 rounded font-semibold text-white transition-colors"
                                      style="background-color: #4f7196;"
                                      onmouseover="this.style.backgroundColor='#3d5a77'"
                                      onmouseout="this.style.backgroundColor='#4f7196'"
                                      [matTooltip]="('chat.goTo' | translate) + (msg.stepTitle ? ': ' + msg.stepTitle : '')"
                                      (click)="navigateToNotificationStep(msg)">
                                <mat-icon class="icon-size-3 text-white" [svgIcon]="'heroicons_mini:arrow-right'"></mat-icon>
                                <span>{{ 'chat.go' | translate }}</span>
                              </button>
                              <span *ngIf="msg.deliveredAt">{{ 'chat.delivered' | translate }}</span>
                              <span *ngIf="msg.readAt && !msg.ackAt">{{ 'chat.read' | translate }} {{ msg.readAt | date:'MMM d, HH:mm' }}</span>
                              <span *ngIf="msg.ackAt">{{ 'chat.acked' | translate }} {{ msg.ackAt | date:'MMM dd, HH:mm' }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #chatEmptyAdmin>
                    <div class="text-center text-gray-500">
                      <mat-icon class="icon-size-12 mb-4" [svgIcon]="'heroicons_outline:chat-bubble-bottom-center-text'"></mat-icon>
                      <p>{{ 'Chat with' | translate }} {{ selectedStudent.name }}</p>
                    </div>
                  </ng-template>
                </div>

                <!-- Pending attachments row (admin) -->
                <div *ngIf="pendingChatAttachments.length > 0"
                     class="flex flex-wrap gap-2 px-4 py-2 border-t bg-gray-50 dark:bg-transparent">
                  <div *ngFor="let att of pendingChatAttachments; let i = index"
                       class="flex items-center gap-2 px-2 py-1 rounded-lg bg-gray-200 dark:bg-gray-700 text-sm">
                    <img *ngIf="att.previewUrl" [src]="att.previewUrl" class="w-10 h-10 rounded object-cover flex-shrink-0" />
                    <mat-icon *ngIf="!att.previewUrl" class="icon-size-5 flex-shrink-0 text-gray-500" [svgIcon]="'heroicons_outline:document'"></mat-icon>
                    <div class="min-w-0 max-w-[120px]">
                      <div class="text-xs font-medium truncate">{{ att.file.name }}</div>
                      <div class="text-[10px] text-gray-500">{{ formatFileSize(att.file.size) }}</div>
                    </div>
                    <div *ngIf="att.uploading" class="w-4 h-4 rounded-full border-2 border-blue-500 border-t-transparent animate-spin flex-shrink-0"></div>
                    <mat-icon *ngIf="att.error" class="icon-size-4 text-red-500 flex-shrink-0" [svgIcon]="'heroicons_mini:exclamation-circle'"></mat-icon>
                    <button class="flex-shrink-0 text-gray-400 hover:text-gray-600 p-0.5" type="button" (click)="removePendingAttachment(i)">
                      <mat-icon class="icon-size-4" [svgIcon]="'heroicons_mini:x-mark'"></mat-icon>
                    </button>
                  </div>
                </div>
                <!-- Message input -->
                <div class="flex items-end p-4 border-t bg-gray-50 dark:bg-transparent">
                  <!-- Attachment button (left) -->
                  <div class="flex items-center h-11 my-px mr-4">
                    <input type="file" #attachmentInputAdmin (change)="onAttachmentSelected($event)" class="hidden" />
                    <button mat-icon-button [attr.aria-label]="'chat.attachFile' | translate" type="button" (click)="attachmentInputAdmin.click()">
                      <mat-icon [svgIcon]="'heroicons_outline:paper-clip'"></mat-icon>
                    </button>
                  </div>
                  <mat-form-field class="fuse-mat-dense fuse-mat-rounded fuse-mat-bold w-full" subscriptSizing="dynamic">
                    <textarea
                      matInput
                      cdkTextareaAutosize
                      [placeholder]="'chat.typeMessage' | translate"
                      [(ngModel)]="adminChatInput"
                      (keydown)="onChatKeydown($event)"
                      (paste)="onChatPaste($event)"></textarea>
                  </mat-form-field>
                  <div class="flex items-center h-11 my-px ml-4">
                    <button mat-icon-button [attr.aria-label]="'chat.sendMessage' | translate" type="button" (click)="sendChatMessage()">
                      <mat-icon [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon>
                    </button>
                  </div>
                </div>
              </ng-container>

              <!-- Students List View -->
              <ng-template #studentsListView>
                <!-- Search -->
                <div class="p-4 border-b">
                  <mat-form-field class="fuse-mat-rounded fuse-mat-dense w-full" subscriptSizing="dynamic">
                    <mat-icon matPrefix class="icon-size-5" [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
                    <input
                      matInput
                      [autocomplete]="'off'"
                      [placeholder]="'chat.searchStudent' | translate"
                      [(ngModel)]="searchTerm"
                      (input)="filterStudents(searchTerm)"
                      #searchField />
                  </mat-form-field>
                </div>

                <!-- Students list -->
                <div class="flex-1 overflow-y-auto">
                  <ng-container *ngIf="filteredStudentsList && filteredStudentsList.length > 0; else noStudents">
                    <ng-container *ngFor="let student of filteredStudentsList; trackBy: trackStudentByFn">
                      <a
                        class="z-20 flex items-center py-4 px-4 cursor-pointer border-b hover:bg-gray-100 dark:hover:bg-hover"
                        [style.border-left]="getUnreadNotificationCount(student.t_ot_studentid) > 0 ? '4px solid #e77e2e' : (getUnreadCount(student.t_ot_studentid) > 0 ? '4px solid #9bbb58' : 'none')"
                        (click)="openStudentChat(student)">
                        <div class="relative flex flex-0 items-center justify-center w-10 h-10">
                          <!-- Unread message badge (green) -->
                          <ng-container *ngIf="(unreadMessageCounts[student.t_ot_studentid] || 0) > 0">
                            <div
                              class="absolute -top-1 -right-1 flex items-center justify-center min-w-5 h-5 px-1 text-white text-xs font-bold rounded-full shadow-sm z-10"
                              style="background-color: #9bbb58;">
                              {{ unreadMessageCounts[student.t_ot_studentid] > 99 ? '99+' : unreadMessageCounts[student.t_ot_studentid] }}
                            </div>
                          </ng-container>
                          <!-- Actionable notifications badge (orange) -->
                          <ng-container *ngIf="(getUnreadNotificationCount(student.t_ot_studentid) || 0) > 0">
                            <div
                              class="absolute -bottom-1 -right-1 flex items-center justify-center min-w-5 h-5 px-1 text-white text-xs font-bold rounded-full shadow-sm z-10"
                              style="background-color: #e77e2e;">
                              {{ getUnreadNotificationCount(student.t_ot_studentid) > 99 ? '99+' : getUnreadNotificationCount(student.t_ot_studentid) }}
                            </div>
                          </ng-container>
                          
                          <ng-container *ngIf="getStudentListAvatarUrl(student)">
                            <img class="w-full h-full rounded-full object-cover" [src]="getStudentListAvatarUrl(student)" alt="Student avatar" />
                          </ng-container>
                          <ng-container *ngIf="!getStudentListAvatarUrl(student)">
                            <div
                              class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                              {{ student.name?.charAt(0) || '?' }}
                            </div>
                          </ng-container>
                        </div>
                        <div class="min-w-0 ml-4 flex-1">
                          <div class="flex items-center gap-1.5">
                            <div class="font-medium leading-5 truncate">{{ student.name }}</div>
                            <!-- Orange dot = supervisor action needed -->
                            <span *ngIf="getUnreadNotificationCount(student.t_ot_studentid) > 0"
                                  class="w-2.5 h-2.5 rounded-full flex-shrink-0"
                                  style="background-color: #e77e2e;"></span>
                            <!-- Green dot = unread chat message -->
                            <span *ngIf="(unreadMessageCounts[student.t_ot_studentid] || 0) > 0"
                                  class="w-2.5 h-2.5 rounded-full flex-shrink-0"
                                  style="background-color: #9bbb58;"></span>
                          </div>
                          <div class="leading-5 truncate text-secondary">{{ student.email }}</div>
                        </div>
                      </a>
                    </ng-container>
                  </ng-container>

                  <!-- No students template -->
                  <ng-template #noStudents>
                    <div class="flex flex-col flex-auto items-center justify-center h-full p-4">
                      <mat-icon class="icon-size-24" [svgIcon]="'heroicons_outline:user-group'"></mat-icon>
                      <div class="mt-4 text-xl font-semibold tracking-tight text-secondary">{{ 'No students found' | translate }}</div>
                    </div>
                  </ng-template>
                </div>
              </ng-template>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</fuse-drawer>

<!-- Lightbox overlay -->
<div *ngIf="lightboxOpen"
     class="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center"
     (click)="closeLightbox()">
  <!-- Main image -->
  <img [src]="lightboxImages[lightboxIndex]?.url"
       class="max-h-[90vh] max-w-[90vw] rounded shadow-2xl object-contain"
       (click)="$event.stopPropagation()" />
  <!-- Prev -->
  <button *ngIf="lightboxImages.length > 1"
          class="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/20 hover:bg-white/40 text-white text-2xl flex items-center justify-center transition-colors"
          (click)="lightboxPrev(); $event.stopPropagation()">‹</button>
  <!-- Next -->
  <button *ngIf="lightboxImages.length > 1"
          class="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/20 hover:bg-white/40 text-white text-2xl flex items-center justify-center transition-colors"
          (click)="lightboxNext(); $event.stopPropagation()">›</button>
  <!-- Close -->
  <button class="absolute top-4 right-4 w-9 h-9 rounded-full bg-white/20 hover:bg-white/40 text-white text-xl flex items-center justify-center transition-colors"
          (click)="closeLightbox()">✕</button>
  <!-- Counter + filename -->
  <div class="absolute bottom-4 left-1/2 -translate-x-1/2 text-white text-sm bg-black/40 px-3 py-1 rounded-full">
    {{ lightboxIndex + 1 }} / {{ lightboxImages.length }}
    <span *ngIf="lightboxImages[lightboxIndex]?.name" class="ml-2 opacity-75">{{ lightboxImages[lightboxIndex].name }}</span>
  </div>
</div>
